module.exports = __webpack_public_path__ + "static/media/kualianqiao.a5029aaa.png";